import React from 'react'
import Nav from './components/nav/nav.js'
import Content from './components/content/content.js';
import Footer from './components/footer/footer.js';
import './App.css';

const App = () => {
  return (
    <>
      <Nav></Nav>
      <Content></Content>
      <Footer></Footer>
    </>
  )
}

export default App
